'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var objectToCamel = require('../lib/object-to-camel.js');

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var createList = configure.configure(function (api) {
  function list() {
    return _list.apply(this, arguments);
  }

  function _list() {
    _list = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var options,
          res,
          data,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _context.next = 3;
              return api.post('key/list', {
                signal: options.signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(options),
                headers: options.headers
              });

            case 3:
              res = _context.sent;
              _context.next = 6;
              return res.json();

            case 6:
              data = _context.sent;
              return _context.abrupt("return", (data.Keys || []).map(function (k) {
                return objectToCamel.objectToCamel(k);
              }));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _list.apply(this, arguments);
  }

  return list;
});
exports.createList = createList;